<!-- Postal/ZIP code form field with label, validation, and formatting. -->

<script lang="ts" setup>
import type { FormFieldController } from '@nzyme/vue-forms/components/defineFormField.js';
import { usePostCodeInput } from '@nzyme/vue-forms/components/usePostCodeInput.jsx';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { vFocus } from '@nzyme/vue-utils/directives/vFocus.js';
import type { Slots } from '@nzyme/vue-utils/slots.js';

import FormFieldWrapper from './FormFieldWrapper.vue';
import * as l from './PostCodeInput.loc.js';

defineProps({
  ...usePostCodeInput.props,
  focus: Boolean,
});

defineEmits(usePostCodeInput.emits);
defineSlots<Slots<{ info: { field: FormFieldController<string> } }>>();

const { PostCodeInput, field } = usePostCodeInput();
const t = useTranslate();
</script>

<template>
  <FormFieldWrapper
    :field="field"
    :label="label || t(l.postalCode)"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
  >
    <template #default="{ inputId }">
      <PostCodeInput
        :id="inputId"
        v-focus="focus"
      />
    </template>

    <template #info>
      <slot
        name="info"
        :field="field"
      />
    </template>
  </FormFieldWrapper>
</template>
